var render = function render(){var _vm=this,_c=_vm._self._c;return _c('hr',{staticClass:"v-divider",class:_vm.classes})
}
var staticRenderFns = []

export { render, staticRenderFns }